import { DOCUMENT_PATH } from 'config/api.routes';
import services from 'service/axios';
import { handleResponse } from 'utils/responseTransformer';

import type { GenericResponse } from 'commons/modules/generic-response';
import type { DocumentUpdloadResponse } from 'commons/modules/service/document-updload';

type DocumentUploadParams = {
  clientId: string;
  contractId: string;
  step: number;
  file: any[];
  coOwnerId: number;
};

const documentUploadService = async ({
  clientId,
  contractId,
  step,
  file,
  coOwnerId,
}: DocumentUploadParams): Promise<GenericResponse<DocumentUpdloadResponse>> => {
  const formdata = new FormData();

  formdata.append('clientId', clientId);
  formdata.append('contractId', contractId);
  formdata.append('coOwnerId', String(coOwnerId || '0'));
  formdata.append('step', String(step));
  file.forEach((f) => {
    formdata.append(`file`, f, f.name);
  });

  try {
    const res = await services.wt_api(`${DOCUMENT_PATH}/upload/multiple`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
      // redirect: 'follow',
      data: formdata,
    });
    const { data, status } = res;
    return handleResponse(data, status, true);
  } catch (error: any) {
    const defaultMessage = 'No se pudo cargar el documento';
    const errorMessagge = error?.response?.data?.message;
    return handleResponse(
      null,
      error?.status,
      false,
      error,
      [],
      errorMessagge || defaultMessage,
    );
  }
};

export default documentUploadService;
